import React, { FC } from 'react';
import { UnderlineTextButton } from '@components/UnderlineTextButton';
import { Typography } from '@mui/material';
import FilterPanelLayout from '@views/Project/components/ModelFiltersPopover/components/FilterPanelLayout';
import FilterValueRow from '@views/Project/components/ModelFiltersPopover/components/FilterValueRow';

type Props = {
  options: string[];
  selected: string[];
  onToggle: (partner: string) => void;
  onClear: () => void;
};

const DashboardPartnersPanel: FC<Props> = ({
  options,
  selected,
  onToggle,
  onClear,
}) => (
  <FilterPanelLayout
    title={
      <Typography variant="h5" color="grey.1000">
        Outsourcing partner
      </Typography>
    }
    action={
      selected.length > 0 && (
        <UnderlineTextButton
          $disabled={false}
          onClick={onClear}
          sx={{ flexShrink: 0 }}
        >
          Clear all
        </UnderlineTextButton>
      )
    }
  >
    {options.map((partner) => (
      <FilterValueRow
        key={partner}
        label={partner}
        checked={selected.includes(partner)}
        onToggle={() => onToggle(partner)}
      />
    ))}
  </FilterPanelLayout>
);

export default DashboardPartnersPanel;
